(function () {
  if (window.RevamSearchCore) return;

  var INDEX_CACHE_KEY = 'gtg:search-index:v2';
  var INDEX_CACHE_TTL = 60 * 60 * 1000;
  var MIN_QUERY_LENGTH = 2;

  var sharedIndex = null;
  var indexPromise = null;

  function readCachedIndex() {
    try {
      var raw = sessionStorage.getItem(INDEX_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !Array.isArray(parsed.products)) return null;
      if (Date.now() - parsed.ts > INDEX_CACHE_TTL) return null;
      return parsed.products;
    } catch (e) { return null; }
  }

  function writeCachedIndex(products) {
    try { sessionStorage.setItem(INDEX_CACHE_KEY, JSON.stringify({ ts: Date.now(), products: products })); }
    catch (e) { /* storage blocked — in-memory cache still works */ }
  }

  // hyphens, spaces, slashes and commas split tokens, so "HZ" matches "AGRK-18V-HZ-BT"
  function tokenize(str) {
    if (!str) return [];
    return String(str).toLowerCase().split(/[\s\-\/_,]+/).filter(Boolean);
  }

  function compactProduct(p) {
    var firstImage = (p.images && p.images.length) ? p.images[0].src : null;
    var secondImage = (p.images && p.images.length > 1) ? p.images[1].src : null;
    var variants = p.variants || [];
    var firstAvail = variants.length ? variants[0] : null;
    var skus = [];
    var skuTokens = [];
    for (var i = 0; i < variants.length; i++) {
      var sku = variants[i].sku;
      if (sku) {
        var skuLow = String(sku).toLowerCase();
        skus.push(skuLow);
        var toks = tokenize(sku);
        for (var j = 0; j < toks.length; j++) if (skuTokens.indexOf(toks[j]) === -1) skuTokens.push(toks[j]);
      }
    }
    return {
      t: p.title || '',                        // title
      v: (p.vendor || ''),                     // vendor
      ty: (p.product_type || ''),              // product type
      tg: tokenize(p.tags || '').join(' '),    // tags
      h: p.handle,                             // url handle
      pid: p.id,                               // product id
      vid: firstAvail ? firstAvail.id : null,  // first variant id
      vc: variants.length,                     // variant count
      sk: skus,                                // variant SKUs, lowercased
      skt: skuTokens,                          // SKU tokens for prefix matching
      sku0: variants.length && variants[0].sku ? String(variants[0].sku) : '', // display SKU
      p: firstAvail ? firstAvail.price : null, // price
      cap: firstAvail ? firstAvail.compare_at_price : null, // compare-at price
      av: firstAvail ? firstAvail.available : true,         // available
      img: firstImage,
      img2: secondImage
    };
  }

  function loadIndex(signal) {
    if (sharedIndex) return Promise.resolve(sharedIndex);
    if (indexPromise) return indexPromise;

    var cached = readCachedIndex();
    if (cached && cached.length) {
      sharedIndex = cached;
      return Promise.resolve(sharedIndex);
    }

    indexPromise = (function () {
      var collected = [];
      var page = 1;
      function next() {
        var url = '/products.json?limit=250&page=' + page;
        return fetch(url, { signal: signal })
          .then(function (r) { if (!r.ok) throw new Error('products.json ' + r.status); return r.json(); })
          .then(function (data) {
            var prods = (data && data.products) || [];
            for (var i = 0; i < prods.length; i++) collected.push(compactProduct(prods[i]));
            if (prods.length === 250) { page++; return next(); }
            return collected;
          });
      }
      return next().then(function (products) {
        sharedIndex = products;
        writeCachedIndex(products);
        indexPromise = null;
        return products;
      }).catch(function (err) {
        indexPromise = null;
        throw err;
      });
    })();
    return indexPromise;
  }

  function bestWordScore(rec, qt) {
    var best = 0;
    var j;

    // title
    var tTokens = tokenize(rec.t);
    for (j = 0; j < tTokens.length; j++) {
      if (tTokens[j].indexOf(qt) === 0) { best = 100; break; }
    }
    if (best < 85 && rec.t.toLowerCase().indexOf(qt) !== -1) best = 85;

    // variant SKUs
    if (best < 70) {
      for (j = 0; j < rec.skt.length; j++) {
        if (rec.skt[j].indexOf(qt) === 0) { best = 70; break; }
      }
      if (best < 50) {
        for (j = 0; j < rec.sk.length; j++) {
          if (rec.sk[j].indexOf(qt) !== -1) { best = 50; break; }
        }
      }
    }

    // vendor / type / tags
    if (best < 30) {
      var vTokens = tokenize(rec.v);
      var tyTokens = tokenize(rec.ty);
      var tgTokens = tokenize(rec.tg);
      var found = false;
      for (j = 0; j < vTokens.length && !found; j++) { if (vTokens[j].indexOf(qt) === 0) found = true; }
      for (j = 0; j < tyTokens.length && !found; j++) { if (tyTokens[j].indexOf(qt) === 0) found = true; }
      for (j = 0; j < tgTokens.length && !found; j++) { if (tgTokens[j].indexOf(qt) === 0) found = true; }
      if (found) best = 30;
      else if (rec.v.toLowerCase().indexOf(qt) !== -1
        || rec.ty.toLowerCase().indexOf(qt) !== -1
        || rec.tg.indexOf(qt) !== -1) best = 15;
    }
    return best;
  }

  function scoreProduct(rec, queryLow) {
    if (!queryLow) return 0;
    var qTokens = queryLow.split(/\s+/).filter(Boolean);
    var total = 0;
    for (var i = 0; i < qTokens.length; i++) {
      var s = bestWordScore(rec, qTokens[i]);
      if (s === 0) return 0; // AND: an unmatched word excludes the product
      total += s;
    }
    if (qTokens.length > 1 && rec.t.toLowerCase().indexOf(queryLow) !== -1) total += 40;
    return total;
  }

  function searchProducts(query, limit) {
    if (!sharedIndex || !sharedIndex.length) return [];
    var queryLow = String(query || '').trim().toLowerCase();
    if (queryLow.length < MIN_QUERY_LENGTH) return [];
    var scored = [];
    for (var i = 0; i < sharedIndex.length; i++) {
      var s = scoreProduct(sharedIndex[i], queryLow);
      if (s > 0) scored.push({ rec: sharedIndex[i], score: s });
    }
    scored.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.rec.t.localeCompare(b.rec.t, undefined, { sensitivity: 'base' });
    });
    if (!limit || limit < 0) limit = scored.length;
    var out = [];
    for (var k = 0; k < scored.length && out.length < limit; k++) out.push(scored[k].rec);
    return out;
  }

  // "$1,234.56 USD" — matches the theme's money_with_currency output
  function moneyString(priceStr) {
    if (priceStr == null || priceStr === '') return '';
    var num = Number(priceStr);
    if (isNaN(num)) return '$' + priceStr;
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' USD';
  }

  // "$1,234.56" — matches the theme's `| money` filter
  function money(priceStr) {
    if (priceStr == null || priceStr === '') return '';
    var num = Number(priceStr);
    if (isNaN(num)) return '$' + priceStr;
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function thumb(src, width) {
    if (!src) return '';
    var w = width || 400;
    return src.indexOf('?') !== -1 ? src + '&width=' + w : src + '?width=' + w;
  }

  window.RevamSearchCore = {
    loadIndex: loadIndex,
    searchProducts: searchProducts,
    moneyString: moneyString,
    money: money,
    escapeHtml: escapeHtml,
    thumb: thumb,
    MIN_QUERY_LENGTH: MIN_QUERY_LENGTH
  };
})();
